import axios from 'axios';
import React, { useContext, useState } from 'react'
import { NavLink, useSearchParams } from 'react-router-dom';
import NotificationContext from '../components/toasts/NotificationContext';
import { constants } from '../constants';
import routes from '../routers/helpers/routes';

const ResetPassword = () => {

    const [password1, setPassword1] = useState('');
    const [password2, setPassword2] = useState('');
    const [sending, setSending] = useState(false)
    const [searchParams] = useSearchParams();
    const dataParams= Object.fromEntries([...searchParams]);
    const {showNotification} = useContext(NotificationContext);
    const token = dataParams.token

    const handleSubmit = async() => {
        if(password1 === "" || password1==="") return showNotification('failed', 'Los campos no pueden estar vacíos.')
        if(password1 !== password2){
            return showNotification('failed', 'Las contraseñas no coinciden.')
        } 
        setSending(true)
        const URL = constants.test_host + '/user/change-password'
        await axios.post(URL, {password:password1, token}, {withCredentials: true}, {headers: {
            'Content-Type': 'application/json'
        }})
        .then(({data})=> {
            showNotification('success', data.message)
            setPassword1('');
            setPassword2("");
            setSending(false)
        })
        .catch((err) => {
            console.log(err)
            setSending(false)
            return showNotification('failed', 'Error en el restablecimiento.')
        })
    }

  return (
    <div className='container'>
        <div className='row justify-content-center'>
            <div className='col-lg-4'>
            <div className="card shadow-lg border-0 rounded-lg mt-2">
                <div className="card-header">
                <h5 className="text-center font-weight-light my-2">
                    Restablecimiento de contraseña
                </h5>
                </div>
            
                <div className="card-body" style={{fontSize: 'small'}}>
                <form>
                    <div className="row mb-3">
                
                    <div className="col">
                        <div className="form-floating mb-2 form-outline">
                        <input
                            className="form-control"
                            id="password1"
                            type="password"
                            placeholder="Password"
                            name="password1"
                            value={password1}
                            onChange={({target}) => setPassword1(target.value)}
                            required
                        />
                        <label htmlFor="password1">Nueva contraseña</label>
                        </div>

                        <div className="form-floating mb-2 form-outline">
                            <input
                                className="form-control"
                                id="password2"
                                type="password"
                                placeholder="Contraseña"
                                name="password2"
                                value={password2}
                                onChange={({target}) => setPassword2(target.value)}
                                required
                            />
                            <label htmlFor="password">Repetir Contraseña</label>
                        </div>

                        
                        {sending ? <button class="btn btn-primary btn-sm" type="button" disabled>
                            <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                            Enviando...
                        </button>:
                        <button type='button' className='btn btn-primary btn-sm' onClick={handleSubmit}>Restablecer</button>}
                        </div>

                        <div className="d-flex pt-2 login-options">
                            <NavLink className="nav-link" to={routes.login}>
                                Iniciar Sesión
                            </NavLink>
                        </div>
                        
                        
                    </div>
                </form>
                </div>
            </div>
            </div>
        </div>
    </div>
      )
}

export default ResetPassword
